import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import IdentityAvatarContainer from '../../../../../../../containers/global/identity/IdentityAvatarContainer';
import IdentityNameContainer from '../../../../../../../containers/global/identity/IdentityNameContainer';
import { AVATAR_SIZE_18 } from '../../../../../../../constants/avatar-sizes';

const propTypes = {
  className: PropTypes.string,
  identity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
};

const GradeTagSelectionHeader = ({ identity, className }) => {
  // Takes CSS classes from '../IdentityTagSelection/_styles.scss
  const classes = classNames({
    'identity-tag-selection-heading': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <h3 className="identity-tag-selection-heading-title">
        <span>Set up grade for</span>

        <div className="identity-tag-selection-heading-identity">
          <IdentityAvatarContainer size={AVATAR_SIZE_18} identity={identity} />
          <IdentityNameContainer identity={identity} />
        </div>
      </h3>

      <p className="identity-tag-selection-heading-description">
        Let&apos;s take Waldo&apos;s photo finding skills to the next level!
        Help out by providing your student&rsquo;s grade for{' '}
        <IdentityNameContainer identity={identity} />.
      </p>
    </div>
  );
};

GradeTagSelectionHeader.propTypes = propTypes;

export default GradeTagSelectionHeader;
